<template>
    <v-col cols="12" sm="12">
        <v-container class="app-container">
            <home-title :title="title"></home-title>

            <product-list
                :products="truncatedProducts"
                :use-wrapper-class="!isDesktop && !isSmallScreen"
                :show-pagination="false"
            ></product-list>

            <div v-if="isButtonVisible" class="text-center py-7">
                <v-btn
                    text
                    color="orange lighten-2"
                    class="text-underline-hover"
                    @click="isButtonClicked = true"
                >{{ $t('showMore') }}</v-btn>
            </div>
        </v-container>
    </v-col>
</template>

<script>
    import ProductCard from '../../../app-front/components/product/general-card/GeneralCard';
    import HomeTitle from './HomeTitle';
    import ProductList from '../../../app-front/components/product/product-list/ProductList';

    export default {
        name: 'HomeProducts',
        components: {
            HomeTitle,
            ProductCard,
            ProductList
        },
        props: {
            title: {
                required: true,
                type: String,
            },
            products: {
                required: true,
                type: Array,
            }
        },
        data() {
            return {
                isButtonClicked: false,
            }
        },
        computed: {
            isSmallScreen() {
                return this.$vuetify.breakpoint.width < 300;
            },
            isMobile() {
                return this.$vuetify.breakpoint.width > 300 && this.$vuetify.breakpoint.xsOnly;
            },
            isTablet() {
                return this.$vuetify.breakpoint.smAndUp && this.$vuetify.breakpoint.width < 1200;
            },
            isMedium() {
                return this.$vuetify.breakpoint.width > 1200 && this.$vuetify.breakpoint.mdOnly;
            },
            isDesktop() {
                return this.$vuetify.breakpoint.lgAndUp;
            },
            truncateCountProducts() {
                return this.isSmallScreen ? 1 : this.isMobile ? 2 : this.isTablet ? 3 : this.isMedium ? 4 : 5;
            },
            isManyProducts() {
                return this.products.length > this.truncateCountProducts;
            },
            isButtonVisible() {
                return !this.isButtonClicked && this.isManyProducts;
            },
            truncatedProducts() {
                return this.isButtonVisible
                    ? this.products.slice(0, this.truncateCountProducts)
                    : this.products;
            }
        },
    }
</script>

<style scoped>

</style>
